import { styledThemed as styled } from "../theme";

export const SmallDivider = styled.div`
  width: 50px;
  height: 2px;
  background-color: ${(p) => p.theme.av8.primaryColor};
  margin: 0 auto;
  opacity: 0.35;
`;
